<div class="container-fluid">

  <div [hidden]="submitted">
    <form (ngSubmit)="onSubmit()" #indicatorForm="ngForm">
      <div class="d-flex justify-content-between">
        <h2>{{ indicator.id ? indicator.name : ('INDICATOR.ADD'|translate) }}</h2>
        <div class="">
          <button class="btn btn-primary" (click)="goToList()">{{ 'FUNCTION-BUTTONS.CANCEL' | translate }}</button>
          @if (user?.roles.length>0 && (user?.roles.includes('EDITOR') || user?.roles.includes('ADMIN'))) {
            <button type="submit" class="btn btn-primary"
              >
              {{ 'FUNCTION-BUTTONS.SAVE' | translate }}
            </button>
          }
          <button type="button" class="btn btn-primary" [disabled]="!indicator.id || running"
            (click)="runIndicator()">
            @if (running) {
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            }
            {{ (running ? 'INDICATOR.RUNNING' : 'INDICATOR.RUN') | translate }}
          </button>
        </div>
      </div>

      @if (indicator.lastRun) {
        <p class="text-secondary">
          {{ 'INDICATOR.LAST_RUN' | translate : {lastRunDate: indicator.lastRun | date: 'yyyy-MM-dd HH:mm:ss'} }}
        </p>
      }

      <div class="shadowBox mt-2">
        <!-- Collapsible header -->
        <div class="d-flex justify-content-between align-items-center"
          style="cursor: pointer;"
          (click)="isCollapsed = !isCollapsed">
          <span>{{ 'INDICATOR.CONFIGURATION' | translate }}</span>
          <lucide-icon [name]="isCollapsed ? 'chevron-down' : 'chevron-up'" size="16"></lucide-icon>
        </div>

        <!-- All content inside one collapse div -->
        <div [ngbCollapse]="isCollapsed">

          <div class="form-group mt-2">
            <label for="name">{{ 'INDICATOR.NAME' | translate }}</label>
            <input type="text" class="form-control" id="name" [(ngModel)]="indicator.name" name="name"
              #name="ngModel" required>
              <div [hidden]="name.valid || name.pristine" class="alert alert-danger">
                {{ 'INDICATOR.NAME_REQUIRED' | translate }}
              </div>

              <label for="year">{{ 'INDICATOR.YEAR' | translate }}</label>
              <input type="text" class="form-control" id="year" [(ngModel)]="indicator.year" name="year"
                #year="ngModel" required>
                <div [hidden]="year.valid || year.pristine" class="alert alert-danger">
                  {{ 'INDICATOR.YEAR_REQUIRED' | translate }}
                </div>

                <label for="operation">{{ 'INDICATOR.OPERATION_TYPE' | translate }}</label>
                <select class="form-control" id="operation" [(ngModel)]="indicator.operation"
                  name="operation" #operation="ngModel" required>
                  @for (value of operations; track value) {
                    <option [value]="value.type">
                      {{ value.name }}
                    </option>
                  }
                </select>

                <label for="sector">{{ 'INDICATOR.SECTOR' | translate }}</label>
                <select class="form-control" id="sector" [(ngModel)]="indicator.sector"
                  name="sector">
                  @for (s of sectors; track s) {
                    <option [value]="s.name">{{ s.label }}</option>
                  }
                </select>
              </div>

              <!-- Datasets table -->
              <div class="table-responsive">
                <table class="table table-bordered">
                  <colgroup>
                  <col style="width: 180px">
                  @for (ds of indicator.datasets; track ds) {
                    <col
                      [style.width]="(100 / indicator.datasets.length) + '%'">
                    }
                  </colgroup>
                  <thead>
                    <tr>
                      <td class="describeTextTD"></td>
                      @for (ds of indicator.datasets; track ds; let i = $index) {
                        <td class="dropBoxTD text-center">
                          <b>{{ 'INDICATOR.DATASET' | translate }} {{ i + 1 }}</b>
                          @if (indicator.datasets.length > 2) {
                            <button type="button" class="btn btn-sm btn-outline-danger ms-2"
                              (click)="removeDataset(i)">
                              <lucide-icon name="x" size="16"></lucide-icon>
                            </button>
                          }
                        </td>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Value Column Name -->
                    <tr>
                      <td class="describeTextTD"><b>{{ 'INDICATOR.VALUE_COLUMN_NAME' | translate }}</b></td>
                      @for (ds of indicator.datasets; track ds; let i = $index) {
                        <td class="dropBoxTD">
                          <input type="text" class="form-control"
                            [(ngModel)]="ds.name"
                            [name]="'dsName' + i"
                            [placeholder]="'INDICATOR.VALUE_COLUMN_NAME' | translate">
                          </td>
                        }
                      </tr>

                      <!-- Source Type toggle -->
                      <tr>
                        <td class="describeTextTD"><b>{{ 'INDICATOR.SOURCE_TYPE' | translate }}</b></td>
                        @for (ds of indicator.datasets; track ds; let i = $index) {
                          <td class="dropBoxTD">
                            <div class="btn-group btn-group-sm" role="group">
                              <input type="radio" class="btn-check"
                                [name]="'sourceType' + i"
                                [id]="'srcService' + i"
                                value="service"
                                [(ngModel)]="ds.sourceType"
                                (change)="onSourceTypeChange(i)">
                                <label class="btn btn-outline-primary" [for]="'srcService' + i">
                                  {{ 'INDICATOR.SOURCE_SERVICE' | translate }}
                                </label>
                                <input type="radio" class="btn-check"
                                  [name]="'sourceType' + i"
                                  [id]="'srcReport' + i"
                                  value="report"
                                  [(ngModel)]="ds.sourceType"
                                  (change)="onSourceTypeChange(i)">
                                  <label class="btn btn-outline-primary" [for]="'srcReport' + i">
                                    {{ 'INDICATOR.SOURCE_REPORT' | translate }}
                                  </label>
                                </div>
                              </td>
                            }
                          </tr>

                          <!-- Services (service mode only) -->
                          <tr>
                            <td class="describeTextTD"><b>{{ 'INDICATOR.SERVICES' | translate }}</b></td>
                            @for (ds of indicator.datasets; track ds; let i = $index) {
                              <td class="dropBoxTD">
                                @if (ds.sourceType !== 'report') {
                                  <select
                                    [(ngModel)]="ds.service"
                                    [name]="'service' + i"
                                    class="form-control"
                                    (change)="onChangeService($event.target.value, i)">
                                    @for (value of services; track value) {
                                      <option [value]="value.id">
                                        {{ value.name }}
                                      </option>
                                    }
                                  </select>
                                }
                                @if (ds.sourceType === 'report') {
                                  ----
                                }
                              </td>
                            }
                          </tr>

                          <!-- Datasets / FileFormat (service mode only) -->
                          <tr>
                            <td class="describeTextTD">{{ 'INDICATOR.DATASETS' | translate }}</td>
                            @for (ds of indicator.datasets; track ds; let i = $index) {
                              <td class="dropBoxTD">
                                @if (ds.sourceType !== 'report') {
                                  <select
                                    [(ngModel)]="ds.fileFormat"
                                    [name]="'fileFormat' + i"
                                    class="form-control"
                                    (change)="onChangeFileFormat($event.target.value, i)">
                                    @for (value of fileFormats[i]; track value) {
                                      <option [value]="value.name">
                                        {{ value.name }}
                                      </option>
                                    }
                                  </select>
                                }
                                @if (ds.sourceType === 'report') {
                                  ----
                                }
                              </td>
                            }
                          </tr>

                          <!-- Report (report mode only) -->
                          <tr>
                            <td class="describeTextTD"><b>{{ 'INDICATOR.REPORTS' | translate }}</b></td>
                            @for (ds of indicator.datasets; track ds; let i = $index) {
                              <td class="dropBoxTD">
                                @if (ds.sourceType === 'report') {
                                  <select
                                    [(ngModel)]="ds.reportId"
                                    [name]="'reportId' + i"
                                    class="form-control"
                                    (change)="onChangeReport($event.target.value, i)">
                                    @for (r of reports; track r) {
                                      <option [value]="r.id">
                                        {{ r.name }}
                                      </option>
                                    }
                                  </select>
                                }
                                @if (ds.sourceType !== 'report') {
                                  ----
                                }
                              </td>
                            }
                          </tr>

                          <!-- Match -->
                          <tr>
                            <td class="describeTextTD">{{ 'INDICATOR.MATCH' | translate }}</td>
                            @for (ds of indicator.datasets; track ds; let i = $index) {
                              <td class="dropBoxTD">
                                @if (ds.sourceType !== 'report') {
                                  <select
                                    [(ngModel)]="ds.match"
                                    [name]="'match' + i"
                                    class="form-control">
                                    @for (value of mappingObjects[i]; track value) {
                                      <option [value]="value.name">
                                        {{ value.name }}
                                      </option>
                                    }
                                  </select>
                                }
                                @if (ds.sourceType === 'report') {
                                  <select
                                    [(ngModel)]="ds.match"
                                    [name]="'matchR' + i"
                                    class="form-control">
                                    @for (value of reportColumns[i]; track value) {
                                      <option [value]="value.key">
                                        {{ value.name }}
                                      </option>
                                    }
                                  </select>
                                }
                              </td>
                            }
                          </tr>

                          <!-- Compare -->
                          <tr>
                            <td class="describeTextTD">{{ 'INDICATOR.COMPARE' | translate }}</td>
                            @for (ds of indicator.datasets; track ds; let i = $index) {
                              <td class="dropBoxTD">
                                <!--                                    {{reportCompareFields[i] | json}}-->
                                <!--                                    {{compareFields[i]}}-->
                                @if (ds.sourceType !== 'report') {
                                  <ntr-multiple-select
                                    #compareSelect
                                    [items]="compareFields[i]"
                                    [key]="'name'"
                                    [placeholder]="'Select compare field'"
                                    [display]="'name'"
                                    [activeItems]="ds.compare"
                                    (onUpdate)="onCompareChange($event, i)">
                                  </ntr-multiple-select>
                                }
                                @if (ds.sourceType === 'report') {
                                  <ntr-multiple-select
                                    [userCompare]="true"
                                    [items]="reportCompareFields[i]"
                                    [key]="'key'"
                                    [placeholder]="'Select compare field'"
                                    [display]="'name'"
                                    [activeItems]="ds.compare"
                                    (onUpdate)="onCompareChange($event, i)">
                                  </ntr-multiple-select>
                                }
                              </td>
                            }
                          </tr>

                          <!-- Date Columns (service mode only) -->
                          <!--                            <tr>-->
                          <!--                                <td class="describeTextTD">{{ 'INDICATOR.DATE_COLUMNS' | translate }}</td>-->
                          <!--                                <td *ngFor="let ds of indicator.datasets; let i = index" class="dropBoxTD">-->
                          <!--                                    <select *ngIf="ds.sourceType !== 'report'"-->
                          <!--                                            [(ngModel)]="ds.date"-->
                          <!--                                            [name]="'date' + i"-->
                          <!--                                            class="form-control">-->
                          <!--                                        <option *ngFor="let value of dateFields[i]" [value]="value.name">-->
                          <!--                                            {{ value.name }}-->
                        <!--                                        </option>-->
                      <!--                                    </select>-->
                    <!--                                </td>-->
                  <!--                            </tr>-->
                </tbody>
              </table>
            </div>

            <!--                    &lt;!&ndash; Add dataset button &ndash;&gt;-->
            <!--                    <div class="mt-2 mb-2">-->
            <!--                        <button type="button" class="btn btn-outline-primary" (click)="addDataset()">-->
            <!--                            <lucide-icon name="plus" size="16"></lucide-icon>&nbsp;{{ 'INDICATOR.ADD_DATASET' | translate }}-->
          <!--                        </button>-->
        <!--                    </div>-->

        <!-- Filter by dates & Amount Percentage -->
        <!--                    <table style="margin: 0 auto; width: 30%;">-->
        <!--                        <tr>-->
        <!--                            <td class="dropBoxTD">{{ 'INDICATOR.FILTER_BY_DATES' | translate }}</td>-->
        <!--                            <td class="dropBoxTD">-->
        <!--                                <input type="date" class="form-control"-->
        <!--                                       [(ngModel)]="indicator.filterDateFrom"-->
        <!--                                       [max]="toDateString(indicator.filterDateTo)"-->
        <!--                                       id="dateFrom" name="filterDateFrom"-->
        <!--                                       (change)="onDateFromChange()">-->
      <!--                            </td>-->
      <!--                            <td class="dropBoxTD">-->
      <!--                                <input type="date" class="form-control"-->
      <!--                                       [(ngModel)]="indicator.filterDateTo"-->
      <!--                                       [min]="toDateString(indicator.filterDateFrom)"-->
      <!--                                       id="dateTo" name="filterDateTo"-->
      <!--                                       (change)="onDateToChange()">-->
    <!--                            </td>-->
  <!--                        </tr>-->
  <!--                        <tr>-->
  <!--                            <td class="dropBoxTD">{{ 'INDICATOR.AMOUNT_PERCENTAGE' | translate }}</td>-->
  <!--                            <td class="dropBoxTD">-->
  <!--                                <input type="number" class="form-control" id="percentageLeft"-->
  <!--                                       [(ngModel)]="indicator.percentageMin"-->
  <!--                                       name="percentageLeft">-->
<!--                            </td>-->
<!--                            <td class="dropBoxTD">-->
<!--                                <input type="number" class="form-control" id="percentageRight"-->
<!--                                       [(ngModel)]="indicator.percentageMax"-->
<!--                                       name="percentageRight">-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                    </table>-->

<!-- Risk Management -->
<table style="width: 100%;">
  <tr>
    <td>
      <div class="form-check form-switch">
        <input mdbCheckbox class="form-check-input" type="checkbox"
          id="riskManagement" name="riskManagement"
          [checked]="indicator?.riskManagement"
          (change)="onCheckboxChange($event)"/>
          <label class="form-check-label" for="riskManagement">
            {{ 'INDICATOR.RISK_MANAGEMENT' | translate }}
          </label>
        </div>
        @if (indicator.riskManagement) {
          <app-risk-management [indicator]="indicator"
          ></app-risk-management>
        }
      </td>
    </tr>
  </table>

</div>
</div>
</form>
</div>

<!-- Results -->
@if (columns) {
  <div class="d-flex flex-column mt-5 justify-content-start shadowBox">
    <div class="mt-3">
      <button class="btn btn-sm btn-outline-success" (click)="export$()" [disabled]="exporting">
        @if (exporting) {
          <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        }
        @if (!exporting) {
          <lucide-icon name="file-spreadsheet" size="16"></lucide-icon>
          }<span class="d-none d-md-inline">&nbsp;{{ 'CSV.EXCEL_DOWNLOAD' | translate }}</span><span class="d-md-none">&nbsp;XLS</span>
        </button>
      </div>
      <div class="mt-2">
        <ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'indicator'"
          [disableHeader]="false"
          (onQuery)="onGridQuery($event)"
          [columns]="columns"
          [actionButtons]="false">
        </ntr-datatable>
      </div>
    </div>
  }

</div>